import React from 'react'
import { Stack } from '@hub/stack'
import { Link } from '@hub/link'
import { As } from '@hub/design-system-base'

interface TileLinkProps {
  url: string
  isLastChild?: boolean
  as?: As
}

const TileLink: React.FC<TileLinkProps> = ({
  url,
  isLastChild = false,
  children,
  as,
}) => (
  <Link
    href={url}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: ['smoke', 'smoke', 'transparent', 'transparent'],
      borderRightWidth: isLastChild ? 'none' : ['0px', '0px', '1px '],
      borderRightStyle: isLastChild ? 'none' : 'solid',
      borderRightColor: isLastChild
        ? 'transparent'
        : ['transparent', 'transparent', 'ghost', 'ghost'],
      _last: {
        borderRightWidth: '0',
      },
    }}
  >
    <Stack
      align="center"
      justify="center"
      sx={{
        paddingX: 'spacing-sm',
        paddingY: 'spacing-md',
        minWidth: '132px',
      }}
      as={as}
    >
      {children}
    </Stack>
  </Link>
)

export default TileLink
